'use client';

import { t } from 'media-chrome';
import { RefObject } from 'react';

import { Button } from '@/components/atoms';

import { AirPlayIcon, ChromecastIcon } from '../common';
import { CastType } from '../types';
import { useCastType } from '../useCastType';
import { useVimeoCastAvailability } from './useVimeoCastAvailability';

import type { VimeoVideoElement } from '@/lib/player/types';

interface Props {
  videoRef: RefObject<VimeoVideoElement | null>;
  disabled?: boolean;
}

export function VimeoCastButton({ videoRef, disabled = false }: Props) {
  const isCastAvailable = useVimeoCastAvailability(videoRef);
  const castType = useCastType();

  if (!castType || !isCastAvailable) {
    return;
  }

  const CastIcon = castType === CastType.AIRPLAY ? AirPlayIcon : ChromecastIcon;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    void videoRef.current?.api?.remotePlaybackPrompt();
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={disabled}
      onClick={handleClick}
      aria-label={
        castType === CastType.AIRPLAY ? t('Start airplay') : t('Start casting')
      }
    >
      <CastIcon />
    </Button>
  );
}
